
export const categories = [
    {
        "id" : 1,
        "slug" : "esportes",
        "name" : "Esporte e Lazer"
    },
    {
        "id" : 2,
        "slug" : "bebe-criancas",
        "name" : "Bebê e Crianças"
    },
    {
        "id" : 3,
        "slug" : "beleza",
        "name" : "Beleza"
    },
    {
        "id" : 4,
        "slug" : "cine-foto",
        "name" : "Cine e Foto"
    },
    {
        "id" : 5,
        "slug" : "viagem",
        "name" : "Viagens"
    },
    {
        "id" : 6,
        "slug" : "eletrodomesticos",
        "name" : "Eletrodomésticos"
    },
    {
        "id" : 7,
        "slug" : "eletronicos",
        "name" : "Eletrônicos"
    },
    {
        "id" : 8,
        "slug" : "livros",
        "name" : "Livros"
    },
    {
        "id" : 9,
        "slug" : "smartphone-tablet",
        "name" : "Smartphones e Tablets"
    },
    {
        "id" : 10,
        "slug" : "games",
        "name" : "Games"
    }
]